import {useMutation, useQuery} from '@tanstack/react-query';
import {
  getAnalysis,
  getFileSettings,
  getExceptionFileTypes,
  getFolders,
  getMetadataFields,
  getProductionListBySetId,
  getProductionSets,
  getSlipSheets,
  getSourceSelection,
  batchPrintSave,
} from '../../api/endpoints/documentPrintingApi';
import {
  IAnalysisRequest,
  IAnalysisResponse,
  IFileSettingsResponse,
  IExceptionFileTypesRequest,
  IExceptionFileTypesResponse,
  IFolderTreeResponse,
  IMetadataField,
} from '../../api/types/documentPrinting.type';

export const useGetSourceSelection = () => {
  return useQuery({
    queryKey: ['getSourceSelection'],
    queryFn: () => getSourceSelection(),
  });
};
export const useGetProductionSets = () => {
  return useQuery({
    queryKey: ['getProductionSets'],
    queryFn: () => getProductionSets(),
  });
};

export const useGetProductionListBySetId = (queryParams: number | string) => {
  return useQuery<any[], Error>({
    queryKey: ['getProductionListBySetId', queryParams],
    queryFn: () => getProductionListBySetId(queryParams),
  });
};

export const useGetAnalysis = (payload: IAnalysisRequest) => {
  return useQuery<IAnalysisRequest, Error, IAnalysisResponse>({
    queryKey: ['getAnalysis', payload],
    queryFn: () => getAnalysis(payload),
  });
};

export const useGetFolders = () => {
  return useQuery<IFolderTreeResponse, Error>({
    queryKey: ['getFolders'],
    queryFn: getFolders,
  });
};

export const useGetMetadataFields = (enabled: boolean) => {
  return useQuery<IMetadataField[], Error>({
    queryKey: ['getMetadataFields'],
    queryFn: () => getMetadataFields(),
    enabled: enabled,
  });
};

export const useFileSettings = (isProductionPrint: boolean) => {
  return useQuery<IFileSettingsResponse, Error>({
    queryKey: ['getFileSettings', isProductionPrint],
    queryFn: () => getFileSettings(isProductionPrint),
  });
};

export const useGetExceptionFileTypes = (
  payload: IExceptionFileTypesRequest
) => {
  return useQuery<
    IExceptionFileTypesRequest,
    Error,
    IExceptionFileTypesResponse
  >({
    queryKey: ['getExceptionFileTypes', payload],
    queryFn: () => getExceptionFileTypes(payload),
  });
};

export const useBatchPrintSave = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: batchPrintSave,
    mutationKey: ['savebatchPrint'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
export const useGetSlipSheets = () => {
  return useQuery<
    {
      metadataList: any[];
      folderList: any[];
      tagList: any[];
      redactionTagList: any[];
      commentsList: any[];
      assignmentList: any[];
    },
    Error
  >({
    queryKey: ['getSlipSheets'],
    queryFn: () => getSlipSheets(),
  });
};
